<template>
    <v-list-item
        v-if="url"
        :href="url"
        target="_blank"
        rel="noopener"
        active-class="white--text"
        class="item-menu"
    >
        <v-list-item-action>
            <v-icon class="item-menu">{{ icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
            <v-list-item-title class="item-menu"> {{ title }}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    <v-list-item
        v-else
        :to="{'name': routeName}"
        active-class="white--text"
        class="item-menu"
    >
        <v-list-item-action>
            <v-icon class="item-menu">{{ icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
            <v-list-item-title class="item-menu"> {{ title }}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    export default {
        name: 'MenuItem',
        props: {
            icon: String,
            title: String,
            routeName: String,
            url: String
        }
    }
</script>

<style scoped>
    .item-menu {
        color: white;
        font-size: 13px;
    }

    /* Força alinhamento à esquerda para todos os títulos */
    .v-list-item__title {
        text-align: left !important;
        justify-content: flex-start !important;
    }

    .v-list-item__content {
        text-align: left !important;
        align-items: flex-start !important;
        margin-left: 4px !important;
        transition: all 0.3s ease;
    }

    .v-list-item {
        justify-content: flex-start !important;
        transition: all 0.2s ease;
        border-radius: 0;
        margin: 1px 6px;
        background: transparent !important;
    }

    .v-list-item:hover {
        transform: none;
        box-shadow: none;
        background-color: transparent !important;
    }

    .v-list-item:hover .v-list-item__content {
        transform: translateX(3px);
    }

    .v-list-item:hover .v-list-item__action {
        transform: translateX(2px);
    }

    .v-list-item__action {
        margin-right: 6px !important;
        transition: all 0.3s ease;
    }

    .v-icon.item-menu {
        font-size: 18px !important;
    }
</style>
